import { Autocomplete, Grid, Box, TextField, Button, Typography, IconButton } from "@mui/material";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import API from "../../../../api";
import { DataGridPro } from "@mui/x-data-grid-pro"
import { useState, useEffect } from "react";
import { boxStyle, dataGridStyle } from "../../../../theme";
import { startToast, updateToastSuccess } from '../../../../utils/notification-loading';


const ReturnTickets = () => {
  const [lecss, setLecss] = useState([])
  const [hardwareTickets, setHardwareTickets] = useState([])
  const [selectedTicket, setSelectedTicket] = useState({})
  const [selectedLecs, setSelectedLecs] = useState("")

  useEffect(() => {
    API.get_lecs()
      .then(res => {
        let lecsArray = []
        res.data.devices.forEach(item => {
          lecsArray.push(item.matricola)
        })
      
     setLecss(lecsArray);
      
    })
  }, [])

  useEffect(() => {
      if(hardwareTickets.length > 0)
      {
        let newArray = [];
        for(let i = 0; i < hardwareTickets.length; i++)
          newArray.push(hardwareTickets[i].matricola);
        const result = lecss.filter(item => !newArray.includes(item));
        setLecss(result);
      }
      else setLecss(lecss);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- this effect sets lecss to a new filtered array derived from itself; adding lecss as a dep would make it re-trigger itself in a loop
  }, [hardwareTickets])

    useEffect(() => {
      API.getHardwareTickets().then(res => {
        const transformedData = res.data.map(item => ({
          id: item._id,
          ...item
        }))
        setHardwareTickets(transformedData)
      })
    }, [])

  const TOCreateNewHardwareTicket = () => {
    startToast("Hardware type Ticket Successfully Created");
    API.createHardwareTickets({ serial_number: selectedLecs }).then(res => {
      updateToastSuccess();
      API.getHardwareTickets().then(res => {
        const transformedData = res.data.map(item => ({
          id: item._id,
          ...item
        }))
        setHardwareTickets(transformedData)
        setSelectedLecs("")
      })
    })
  }

  const columns = [
          {
              field: "matricola",
              headerName: "SERIAL NUMBER",
              minWidth: 100,
              flex: 1,
              headerAlign: "left",
              align: "left",
              filterable: false
          },
          {
              field: "fase",
              headerName: "PHASE",
              minWidth: 120,
              flex: 1,
              headerAlign: "left",
              align: "left",
              filterable: false,
              renderCell: (params) => (
                <Typography>{params.value}/6</Typography>
              )
          },
          {
              field: "lastUpdate",
              headerName: "LAST UPDATE",
              minWidth: 140,
              flex: 1,
              headerAlign: "left",
              align: "left",
              filterable: false
          },
          {
              field: "detail",
              headerName: "DETAIL",
              minWidth: 170,
              flex: 1,
              headerAlign: "left",
              align: "left",
              filterable: false,
              renderCell: (cellValues) => (
                  <Button
                    sx={{
                      backgroundColor: "#2d2d2d !important",
                      "&:hover": {
                        backgroundColor: "#eaeaea !important",
                        color: "#131C2D !important",
                      },
                    }}
                      style={{ fontWeight: "bold" }}
                      className="selectButton"
                      onClick={() => {
                          setSelectedTicket(cellValues.row)
                      }}
                  >
                      More Detail
                  </Button>
              ),
          }
      ]
  
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs:12 , md: 7 }}>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}>

          <Box sx={[boxStyle, {p: 2, height: "30vh", display: "flex", justifyContent: "space-between"}]}>
            <Autocomplete
              options={lecss}
              getOptionLabel={(option) => option}
              value={selectedLecs}
              onChange={(event, newValue) => {
                  setSelectedLecs(newValue);
              }}
              renderInput={(params) => (
                  <TextField sx={{
                    width:{xs:"40vw", md:"20vw"},
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#76c7c0",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#459296",
                      },
                    },
                  }} 
                  {...params} 
                  label="INSERT DAMAGED LECS" 
                  variant="outlined" />
              )}
            />
            <Button
              onClick={TOCreateNewHardwareTicket}
              variant='contained'
              sx={{
                  backgroundColor: '#874919',
                  "&:hover": {
                      backgroundColor: "whitesmoke !important",
                      color: "#131C2D",
                  },
              }}
              style={{ fontWeight: "bold" }}
              disabled={!selectedLecs}
            >
              Start a new Procedure for replacement of Lecs
            </Button>
          </Box>
          
          <Box sx={{height: "50vh"}}>
            <DataGridPro
              rows={hardwareTickets}
              columns={columns}
              pagination
              autoPageSize
              sx={dataGridStyle}
            />
          </Box>

        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        {selectedTicket._id ? (
          <Box sx={[boxStyle, {p:2}]}>
            <ToDoList ticket={selectedTicket} setSelectedTicket={setSelectedTicket}/>
          </Box>
        ) : (
          <Box sx={[boxStyle, {p:2, display: "flex", alignItems: "center", justifyContent: "center"}]}>
            <Typography sx={{ fontSize: 18, textAlign: "center" }}>Click on "MORE DETAIL" to view the hardware status</Typography>
          </Box>
        )}
      </Grid>
    </Grid>
  )
}

export default ReturnTickets;


const ToDoList = ({ ticket, setSelectedTicket }) => {
  return (
    <Box gap={6} sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box>
        <IconButton onClick={() => { setSelectedTicket({}) }}><CloseIcon /></IconButton>
      </Box>

      <Box sx={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <Typography sx={{ fontSize: 18 }}>LECS S.N: <b>{ticket.matricola}</b></Typography>
        <Typography sx={{ fontSize: 18 }}>Last Update: <b>{new Date(ticket.lastUpdate).toLocaleString()}</b></Typography>
      </Box>
      <Box sx={{ display: 'flex', color: (ticket.fase >= 1 ? "#459296" : '#999797') }}>
        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>{ticket.fase >= 1 ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}Ethernet cable control</Typography>
      </Box>
      <Box sx={{ display: 'flex', color: (ticket.fase >= 2 ? "#459296" : '#999797') }}>
        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>{ticket.fase >= 2 ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}Verification of LAN ports</Typography>
      </Box>
      <Box sx={{ display: 'flex', color: (ticket.fase >= 3 ? "#459296" : '#999797') }}>
        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>{ticket.fase >= 3 ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}IP Assignment to LECS</Typography>
      </Box>
      <Box sx={{ display: 'flex', color: (ticket.fase >= 4 ? "#459296" : '#999797') }}>
        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>{ticket.fase >= 4 ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}Mirror Port Verification on LECS Enterprise</Typography>
      </Box>

      <Box sx={{ display: 'flex', color: (ticket.fase >= 5 ? "#459296" : '#999797') }}>
        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>{ticket.fase >= 5 ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}Firewall and log verification</Typography>
      </Box>

      <Box sx={{ display: 'flex', color: (ticket.fase >= 6 ? "#459296" : '#999797') }}>
        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>{ticket.fase >= 6 ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}Moving the device</Typography>
      </Box>
    </Box>
  )
}